/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import loader from "assets/images/loader.gif";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Slider from "react-slick";
// Material Kit 2 React examples
import { styled } from "@mui/material/styles";

import parse from "html-react-parser";

// Images
import innerCover from "assets/images/banners/banner-iqac.webp";
import iqac from "assets/images/iqac-logo.webp";
import Container from "@mui/material/Container";

import * as React from "react";
import { useQuery } from "@apollo/client";

import { GET_ACTIVITIES } from "../../../graphql/query/iqac";

const SingleSlider = styled("div")({
  marginRight: "20px",
});

// const LogoContainer = styled("div")({
//   display: "flex",
//   justifyContent: "center",
//   height: "150px",
// });
// Material Kit 2 React examples
const settings = {
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
function IQAC() {
  const { loading, error, data } = useQuery(GET_ACTIVITIES, {
    variables: {
      activityFilter: {
        search: null,
        orderColumn: "id",
        orderDirection: "desc",
        status: true,
        limit: 1000000000,
        offset: 0,
      },
    },
  });
  const [activityDatas, setActivityDatas] = React.useState([]);

  React.useEffect(() => {
    if (loading === false) {
      if (error) {
        setActivityDatas([]);
      } else {
        setActivityDatas(data.getActivities.club);
      }
    }
  }, [data, loading, error]);
  return (
    <>
      <MKBox
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${innerCover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
        className="innerCover"
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              IQAC
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: { xs: 4, lg: 4 },
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <div className="row d-flex align-items-center">
            <div className="col-md-6">
              <img src={iqac} className="img-fluid " alt="" />
            </div>
            <div className="col-md-6">
              <MKTypography variant="subtitle1" className="text-j">
                The vision statement of NAAC and the vision statement of SNLC, in unison, maintain
                that quality enrichment and assurance is a key concern. The IQAC at SNLC works
                towards the sustenance of quality of the institution on a daily basis. The foremost
                concern is the enhancement of the academic, co-curricular and administrative
                performance of the college.
                <br />
                The IQAC works towards the development and application of quality benchmarks for the
                various activities of the college. At SNLC, we relentlessly pursue the facilitation
                of a learner-centric environment for high-quality education, depending on state of
                the art technology and a participatory teaching-learning process. The feedback
                system of the institution invites suggestions to improve academic activities and
                IQAC carries out a detailed analysis of the suggestions procured from the students,
                parents and different stakeholders of the institution. We organise workshops,
                seminars, webinars and FDPs and document the various activities of the college.
              </MKTypography>
            </div>
          </div>
        </Container>
        <Container sx={{ mt: 3 }}>
          {loading ? (
            <img alt="loader" src={loader} className="loader" />
          ) : (
            <div>
              {activityDatas.length ? (
                <div>
                  {activityDatas.map((activity) => (
                    <Grid>
                      <Grid container>
                        <Grid item xs={12} md={12} sx={{ mb: 3 }}>
                          <MKTypography sx={{ textAlign: "center" }} variant="h3" color="black">
                            {activity.title}
                          </MKTypography>
                        </Grid>
                      </Grid>

                      <Grid container display="flex" justifyContent="center" mb={2}>
                        <Grid item xs={12} md={12} mx={{ xs: "auto", sm: 6, md: 1 }}>
                          <MKTypography variant="subtitle1" className="text-j">
                            {activity.description ? parse(activity.description) : null}
                            <br />
                          </MKTypography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          {/* <iframe
                        className="club-video"
                        title="video"
                        id="video"
                        width="720"
                        height="400"
                        src={`https://www.youtube.com/embed/${activity.vedio_link}`}
                        frameBorder="0"
                        allow="accelerometer, autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      /> */}
                          {activity.vedio_link ? (
                            <iframe
                              title="video"
                              width="100%"
                              height="250"
                              src={`https://www.youtube.com/embed/${activity.vedio_link}`}
                              allow="accelerometer, autoplay; encrypted-media; gyroscope; picture-in-picture"
                              frameBorder={0}
                            />
                          ) : null}
                          {/* wrapper */}
                        </Grid>
                      </Grid>
                      {activity.ActivityImages.length >= 4 ? (
                        <Slider {...settings}>
                          {activity.length !== 0 && activity.ActivityImages
                            ? activity.ActivityImages.map((ActivityImage) => (
                                <SingleSlider>
                                  <img
                                    className="img-fluid club-slider"
                                    src={ActivityImage.img_link}
                                    alt="Apple"
                                  />
                                </SingleSlider>
                              ))
                            : null}
                        </Slider>
                      ) : (
                        <Grid
                          container
                          spacing={3}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          {activity.ActivityImages.length
                            ? activity.ActivityImages.map((ActivityImag) => (
                                // <ClubCard image={clubImage.img_link} />
                                <img className="clubImg" src={ActivityImag.img_link} alt="" />
                              ))
                            : null}
                        </Grid>
                      )}
                      <hr />
                    </Grid>
                  ))}
                </div>
              ) : null}
            </div>
          )}
        </Container>
      </Card>
    </>
  );
}

export default IQAC;
